// src/guides/GuideEarnings.js
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

const GuideEarnings = () => {
    const { fetchWithAuth, user, loggedIn, loading: authLoading } = useAuth();
    const [earnings, setEarnings] = useState(0);
    const [completed, setCompleted] = useState(0);
    const [loading, setLoading] = useState(true);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        if (!loggedIn || authLoading) return;

        const fetchEarnings = async () => {
            try {
                const encodedEmail = encodeURIComponent(user.email);
                const res = fetchWithAuth(`${API_URL}/earnings?guideEmail=${encodedEmail}`);
                if (!res.ok) throw new Error("Failed to fetch earnings");
                const data = await res.json();
                setEarnings(data.totalEarnings || 0);
                setCompleted(data.completedBookings?.length || 0);
            } catch (err) {
                console.error("Earnings fetch error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchEarnings();
    }, [fetchWithAuth, API_URL, loggedIn, authLoading]);

    if (authLoading || loading) return <p className="guide-earnings-loading">Loading earnings...</p>;
    if (!loggedIn) return <p>Please login to view your earnings.</p>;

    return (
        <div className="guide-earnings card">
            <h3 className="earnings-title">💰 Earnings</h3>
            <p className="earnings-total">
                Total: <span className="amount">₹{earnings}</span>
            </p>
            <p className="earnings-completed">
                Completed Bookings: <span className="count">{completed}</span>
            </p>
        </div>
    );
};

export default GuideEarnings;
